import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AppInfo {
  version?: string;
}

export interface AppInfoStateProps {
  appInfo: AppInfo;
}

const initialState: AppInfoStateProps = {
  appInfo: {},
};

export const AppInfoSlice = createSlice({
  name: "appInfo",
  initialState: initialState,
  reducers: {
    setAppInfo: (state, action: PayloadAction<AppInfo>) => {
      state.appInfo = action.payload;
    },
  },
});

export const AppInfoActions = AppInfoSlice.actions;

export default AppInfoSlice.reducer;
